module.exports = __webpack_public_path__ + "static/media/filter.ed1860ae.webp";